<template>
  <tr
    v-bind:key="result.id">
      <td>{{ result.id }}</td>
      <td>{{ result.name }}</td>
      <td>{{ result.status }}</td>
      <td>{{ result.acres | acresFormat}}</td>
      <td>{{ result.localityName }}</td>
      <td>
        <router-link
          :to="{ name: 'project', params: {
          project_id: result.projectId,
          project_id: result.id }}"
          class="btn btn-secondary btn-sm">
          View
        </router-link>
      </td>
  </tr>
</template>
<script>
export default {
  name: 'ProjectSearchResultRow',
  props: {
    result: {
      type: Object,
    },
  },
};
</script>
